'use strict';

var initializeCarousels = require('./tileRenderCarousel').initializeCarousels;
var getCookie = require('./product/base').getCookie;

/**
 * get user pro status from cookie
 * @returns {boolean} isProUser
 */
function getIsProUser() {
    var customerGroups = getCookie('customergroups');
    if (customerGroups && (customerGroups.includes('PUR-Pro') || customerGroups.includes('PUR-Elite'))) {
        return true;
    }
    return false;
}

function initializeVariables() {
    if (window.$ === undefined) {
        window.jQuery = window.$ = require('jquery');
    }

    if (window.addAjax === undefined) {
        var ajaxQueue = [];
        var ajaxActive = 0;
        window.addAjax = function (obj, ajaxMaxConc) {
            var oldSuccess = obj.success;
            var oldError = obj.error;
            var callback = function () {
                if (ajaxActive <= ajaxMaxConc && ajaxQueue.length > 0) {
                    $.ajax(ajaxQueue.shift());
                } else {
                    ajaxActive--;
                }
            };
            obj.success = function (resp, xhr, status) {
                callback();
                if (oldSuccess) oldSuccess(resp, xhr, status);
            };
            obj.error = function (xhr, status, error) {
                callback();
                if (oldError) oldError(xhr, status, error);
            };
            ajaxQueue.push(obj);

            if(ajaxActive < ajaxMaxConc){
                $.ajax(ajaxQueue.shift());
                ajaxActive++;
            }
        };
    }

    var refreshTileCookie = getCookie('refreshTileCookie');
    let tileCookieExpiry = $('#refreshTileJSONExpiry') ? $('#refreshTileJSONExpiry').val() : 0;
    if(tileCookieExpiry > 0) {
        if(!refreshTileCookie) {
            setCookie('refreshTileCookie',true,tileCookieExpiry);
            clearLocalTileJSON();
        }
    } else {
        //local storage disabled from sitepref
        clearLocalTileJSON();
    }

}

function setCookie(name, value, milisecs = 86400000) {
    const date = new Date();
    date.setTime(date.getTime() + (milisecs));
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; path=/`;
}

function clearLocalTileJSON() {
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key.startsWith('tile_')) {
          localStorage.removeItem(key);
        }
      }
}

/**
 * @param {number} size - size of the image
 * @returns {number} minDimension
 */
function minDimension(size) {
    const minWidthHeight = 120;
    return Math.max(minWidthHeight, Math.floor(size)) * 2;
}


/**
 * @param {Object} context - context of the tile
 * @param {Object} product - product object
 * @returns {void}
 * @description - renders the tile
 */
function renderTile(context, product) {
    let imgContainer = $($(context).find('#render-tile-image')[0]);
    const hasParams = product.image.base[product.image.base.length - 1] === '?';
    let imgLink = `${product.image.base}${hasParams ? '' : '?'}h=${minDimension(imgContainer.height())}&w=${minDimension(imgContainer.width())}&sm=clamp`;
    var tileLinkBlock = $(context).find('.product-tile-link');
    tileLinkBlock.attr('href', product.url);
    tileLinkBlock.attr('title', product.name);
    tileLinkBlock.attr('data-gtmdata', `${JSON.stringify(product)}`);
    var imageLink = $(context).find('#render-tile-image');
    imageLink.attr('style', `background-image: url(${imgLink});`);
    imageLink.attr('title', product.name);
    $(context).find('#render-tile-name').text(product.name);
    $(context).find('.product-tile-link').attr('aria-label', product.name);
    if (product.productPlatform && product.productPlatform.length > 0) {
        $(context)
            .find('.product-tile-availability')
            .append('<span class="pr-1 platform"></span>');
    } else if (product.isGiftCard) {
        $(context)
            .find('.product-tile-availability')
            .append('<span class="pr-1 platform">giftcard</span>');
    }
    if (!!product.ratings.percentage && !!product.ratings.count && product.ratings.count !== '0') {
        $(context).find('.render-tile-ratings span').attr('href', product.url);
        $(context).find('.render-tile-ratings span div').append(`
        <div class="grey-stars star-img">
            <div class="red-stars star-img" style="width:${product.ratings.percentage}%"></div>
        </div>
        <div class="d-inline-block align-text-top rating-count">(${product.ratings.count})</div>
        `);
    }
    context.find('.pdp-link').attr('data-gtmdata', `${JSON.stringify(product)}`);
    var plpFlex = $(context).find('.plp-flex');
    var sellingPriceBlock = $(plpFlex).find('.selling-price-redesign');
    var renderTilePrice = $(context).find('#render-tile-price');
    var basePrice = $(renderTilePrice).find('#render-base-price');
    var salePrice = $(renderTilePrice).find('#render-sale-price');
    var proPrice = $(renderTilePrice).find('#render-pro-price');
    const baseGroup = $(renderTilePrice).find('#render-base-group');
    var marketPriceGroup = $(renderTilePrice).find('#render-market-price-group');
    var gradingBadgeSelector = $(context).find('#render-tile-badge');

    if (product.price.min || product.price.base === '0.01') {
        $(sellingPriceBlock).find('.actual-price .fromPriceLabel').append('From');
    }
    if (product.price.sale) {
        sellingPriceBlock.addClass('has-savings');
    }
    if (product.price.base === '0.01') {
        $(sellingPriceBlock)
            .find('.actual-price')
            .append('$5.00');
        $(salePrice).text('$5.00');
    } else if (product.price.sale || product.price.min || product.price.base) {
        $(sellingPriceBlock)
            .find('.actual-price')
            .append(`$${product.price.sale || product.price.min || product.price.base}`);
        if (product.seePriceInCart && product.hidePricePDP) {
            $(salePrice).text(`Add to cart to see price`);
        } else {
            $(salePrice).text(`$${product.price.sale || product.price.min || product.price.base}`);
        }
    } else {
        $(sellingPriceBlock)
            .find('.actual-price')
            .append('Coming Soon');
        $(salePrice).text('Coming Soon');
    }

    if (product.price.sale && (!product.seePriceInCart && !product.hidePricePDP)) {
        var strikeThrough = $(sellingPriceBlock).find('.selling-price-details .strike-through');
        strikeThrough.attr('content', product.price.base || product.price.max);
        strikeThrough.find('span').append(`$${product.price.base || product.price.max}`);
        $(basePrice).text(`$${product.price.base || product.price.max}`);
        $(salePrice).addClass('render-has-savings');
    }
    if (product.price.pro) {
        if (product.seePriceInCart && (product.hidePricePDP || product.hideProPricePDP)) {
            $(proPrice).html(`<span class="pro-price-amount colored">Pros get 5% extra off</span>`);
        } else {
            $(baseGroup).addClass('has-pro-deal');
            $(proPrice).html(`<span class="pro-price-amount">$${product.price.pro}</span> <span class="pro-price-label">for Pros</span>`);
            var discountDenominator = product.price.sale ? product.price.sale : product.price.base;
            if (!isNaN(discountDenominator)) {
                var discountPercentage = $(context).find('#render-discount-percentage');
                $(discountPercentage).addClass('pro-discount show');
                $(discountPercentage).text(`-${Math.round((1 - (product.price.pro / discountDenominator)) * 100)}%`);
            }
            if (getIsProUser()) {
                $(baseGroup).find('#render-sale-price').addClass('strike-through');
            }
            plpFlex.find('.plp-flex-order-1').append(`
                <span class="savings-indicator-value" id="pro-saving-indicator">
                    <span>
                        <span class="save-label">Pros Save</span>
                        <span>${((product.price.sale ? product.price.sale : product.price.base) - product.price.pro).toFixed(2)}</span>
                    </span>
                </span>
                <span class="pro-day-pricing-2022 pricing show">$${product.price.pro}</span>
                <span class="pro-day-pricing-2022 copy show">Pro Price</span>`);
        }
    }

    if (product.marketPrice) {
        marketPriceGroup.find('#render-market-price-text').text('Market Price: ');
        marketPriceGroup.find('#render-market-price-price').text(`$${Number(product.marketPrice).toFixed(2)}`);
    }

    if (product.providerGrade && product.gradingProvider) {
        if (product.badge) {
            // Don't want to conflict with promo badge
            gradingBadgeSelector.addClass('right');
        }

        var badgeText = `${product.gradingProvider} ${product.providerGrade.replace(/[^\d.]*/g, '')}`;
        gradingBadgeSelector.text(badgeText);
        gradingBadgeSelector.removeClass('d-none');
    }

    if (product.availability.allowBOPS) {
        if (product.bopsPromoAlternate && $('#bopsPromoCalloutSearchTileAlternate') && $('#bopsPromoCalloutSearchTileAlternate').val()) {
            context.find('.render-tile-bops-copy').html($('#bopsPromoCalloutSearchTileAlternate').val());
        } else if ($('#bopsPromoCalloutSearchTile') && $('#bopsPromoCalloutSearchTile').val()) {
            context.find('.render-tile-bops-copy').html($('#bopsPromoCalloutSearchTile').val());
        } else {
            context.find('.render-tile-bops-copy').hide();
        }
    } else {
        context.find('.render-tile-bops-copy').hide();
    }

    if (product.releaseDate) {
        context.find('.render-tile-release-date').text(`Release Date ${product.releaseDate}`);
    } else {
        context.find('.render-tile-release-date').hide();
    }

    if (product.badge) {
        $(context).find('.render-promotion-badge-container').append(`
        <div class="render-badge-indicator ${
            product.badge.toLowerCase().startsWith('pro')
                ? 'purple-bg'
                : product.badge.toLowerCase() === 'bestselling'
                    ? 'orange-bg'
                    : ''
        }">${product.badge}</div>`);
    }
    context.addClass('loaded');
    context.removeClass('unloaded');
}


function setItem(product, productId) {
    //Set item to local storage only if sitepref is enabled and local storage size is < 2 MB
    if ($('#refreshTileJSONExpiry') && $('#refreshTileJSONExpiry').val() > 0 && getLocalStorageSizeinMB() < 2) {
        var localTileItem = getItem(productId);
        let currentTime = Date.now();
        if(localTileItem == undefined || currentTime >= localTileItem.expiresAt) {
            // add expiry to individual tile json
            let tileCookieExpiry = $('#refreshTileJSONExpiry').val();
            product.expiresAt = Date.now()+tileCookieExpiry;
            let pidKey = 'tile_'+productId ;
            localStorage.setItem(pidKey, JSON.stringify(product));
        }
    } 
}

function getLocalStorageSizeinMB() {
    const jsonString = JSON.stringify(localStorage);
    const sizeInBytes = new TextEncoder().encode(jsonString).length;
    const sizeInMB = sizeInBytes / (1024 * 1024);
    return sizeInMB;
}

function getItem(productId) {
    let pidKey = 'tile_'+productId ;
    if (localStorage.getItem(pidKey)) {
        return JSON.parse(localStorage.getItem(pidKey)) ? JSON.parse(localStorage.getItem(pidKey)) : undefined;
    } else {
        return undefined;
    }
}

/**
 * @param {Object} context - context of the tile
 * @param {Array} productIdArray - product id Array
 * @param {boolean} isCarouselPage - is carousel page
 * @param {boolean} useTileImage - use Tile Images View Type
 * @returns {void}
 * @description - sends request to get the tile
 */
function sendRequest(context, productIdArray, isCarouselPage, useTileImage) {
    var queryData = null;
    if(productIdArray.length == 0) {
        let productId = context.attr('id');
        let storedTileItem = getItem(productId);
        if (storedTileItem && Date.now() <= storedTileItem.expiresAt) {
            renderTile($(".product-tile[data-pid='"+productId+"']"), storedTileItem);
        } else {
            queryData = {
                "pid" : productId,
                "useTileImage" : useTileImage
            };
        }
    } else {
        queryData = {
            "data" : productIdArray.join(','),
            "useTileImage" : useTileImage
        };
    }
    if(queryData) {
        var tileShowUrl = context.closest(".product-tile-container").length > 0 ? context.closest(".product-tile-container").data("tile-url") : $('.search-for-tiles-url').val();
        window.addAjax({
            url: tileShowUrl, 
            data: queryData,
            method: 'GET',
            success: function (response) {
                if (response.productsJSON) {
                    Object.entries(response.productsJSON).forEach(([productID, productJSON]) => {
                        setItem(productJSON, productID);
                        renderTile($(".product-tile[data-pid='"+productID+"']"), productJSON);
                        });
                } else if (response.product) {
                    //Do not setItem here as this will store regular PLP tiles
                    renderTile($(".product-tile[data-pid='"+response.product.id+"']"), response.product);
                }
            },
            error: function (xhr, status, error) {
                if (xhr.status === 429) {
                    sendRequest(context, productIdArray, isCarouselPage, useTileImage);
                }
            }
        }, isCarouselPage ? 5 : 3);
    }
}

/**
 * @param {Object} context - context of the tile
 * @param {boolean} isCarouselPage - is carousel page
 * @param {Array} productIdArray - Array of tile produc ids
 * @returns {void}
 * @description - queries the tiles
 */
function queryTiles(context, isCarouselPage, useTileImage, productIdArray) {
    sendRequest(context, productIdArray, isCarouselPage, useTileImage);
}

/**
 * @param {Object} tilesToRender - elements with className product-tile-render
 * @param {boolean} pageHasCarousels - is carousel page
 * @returns {void}
 * @description - queries the tiles
 */
function syncTiles(tilesToRender, pageHasCarousels, useTileImage) {
    if (tilesToRender.length > 0) {
        var productIdArray = [];
        var context = $(tilesToRender[0]);
        var tileShowUrl = context.closest(".product-tile-container").length > 0 ? context.closest(".product-tile-container").data("tile-url") : $('.search-for-tiles-url').val();
        var isPidList = tileShowUrl.indexOf('GetProductsJSON') >= 0;
        for (let i = 0; i < tilesToRender.length; i++) {
            var tile = $(tilesToRender[i]);
            if (!tile.hasClass('loaded') && !tile.hasClass('unloaded')) {
                tile.addClass('unloaded');
                if(isPidList) {
                    let pid = tile.attr('id');
                    let storedTileItem = getItem(pid);
                    if (storedTileItem && Date.now() <= storedTileItem.expiresAt) {
                        renderTile($(".product-tile[data-pid='"+pid+"']"), storedTileItem);
                    } else {
                        productIdArray.push(pid);
                    }            
                } else {
                    queryTiles(tile, pageHasCarousels, useTileImage, productIdArray);
                }
            }
        }
        if(productIdArray.length > 0 && isPidList){
            queryTiles(tile, pageHasCarousels, useTileImage, productIdArray);
        }
        
    }
}

initializeVariables();

const carousels = $('.carousel-slider');
if (carousels.length > 0) {
    initializeCarousels(carousels);
}

const useTileImage = document.URL.includes('/digital-store') && !!document.querySelector('.page-designer');
const tilesToRender = $('.product-tile-render');
if (tilesToRender.length > 0) {
    syncTiles(tilesToRender, true, useTileImage);
}

var page = document.getElementsByTagName("body")[0];
const observer = new MutationObserver((mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            for (let node of mutation.addedNodes) {
                if (node.nodeType !== Node.TEXT_NODE && node.nodeType !== Node.COMMENT_NODE) {
                    const nodes = node.getElementsByClassName("carousel-slider");
                    const pageHasCarousels = nodes.length > 0;
                    if (pageHasCarousels) {
                        initializeCarousels(nodes);
                    }
                    const tilesToRender = node.getElementsByClassName('product-tile-render');
                    if(tilesToRender.length > 0){
                        syncTiles(tilesToRender, pageHasCarousels, useTileImage);
                    }
                }
            }
        }
    }
});
observer.observe(page, { attributes: false, childList: true, subtree: true });
